<template>
  <div class="page" :class="{'page__has-bar': !readonly}">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据编号</label>
            <em class="weui-form-preview__value">{{ form.main.wr_code }}</em>
          </div>
        </div>
        <custom-layout class="weui-form-preview__bd" :view-config="customViewConfig">
          <div class="weui-form-preview__item" slot="wr_pleaseman">
            <label class="weui-form-preview__label">{{customLabel.wr_pleaseman || "报告人"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.wr_pleaseman
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="wr_department">
            <label class="weui-form-preview__label">{{customLabel.wr_department || "报告部门"}}</label>
            <span class="weui-form-preview__value"
              >{{ form.main.wr_department }}
              </span>
          </div>
          <div class="weui-form-preview__item" slot="wr_type">
            <label class="weui-form-preview__label">{{customLabel.wr_type || "报告类别"}}</label>
            <span
              class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ form.main.wr_type }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="wr_date" v-if="form.main.wr_type == '日报'">
            <label class="weui-form-preview__label">{{customLabel.wr_date || "报告日期"}}</label>
            <span class="weui-form-preview__value"
              >{{ dateFormat(form.main.wr_date, 'yyyy-MM-dd') }}
              </span>
          </div>
          <div class="weui-form-preview__item" slot="wr_startdate" v-if="form.main.wr_type == '周报'">
            <label class="weui-form-preview__label">{{customLabel.wr_startdate || "起始日期"}}</label>
            <span class="weui-form-preview__value"
              >{{ dateFormat(form.main.wr_startdate, 'yyyy-MM-dd') }}
              </span>
          </div>
          <div class="weui-form-preview__item" slot="wr_enddate" v-if="form.main.wr_type == '周报'">
            <label class="weui-form-preview__label">{{customLabel.wr_enddate || "截止日期"}}</label>
            <span class="weui-form-preview__value"
              >{{ dateFormat(form.main.wr_enddate, 'yyyy-MM-dd') }}
              </span>
          </div>
          <div class="weui-form-preview__item" slot="wr_yearmonth" v-if="form.main.wr_type == '月报'">
            <label class="weui-form-preview__label">{{customLabel.wr_yearmonth || "月报期间"}}</label>
            <span class="weui-form-preview__value"
              >{{ form.main.wr_yearmonth }}
              </span>
          </div>
          <div class="weui-form-preview__item" slot="wr_ccrecipients">
            <label class="weui-form-preview__label">{{customLabel.wr_ccrecipients || "抄送人"}}</label>
            <span class="weui-form-preview__value"
              >{{ form.main.wr_ccrecipients }}
              </span>
          </div>
        </custom-layout>
      </div>
      <collapse class="form-preview weui-form-preview" v-if="form.items1" :title="'工作总结（'+form.items1.length+'条）'">
        <div
          class="weui-form-preview__bd form-detail-preview"
          v-for="(item, index) in form.items1"
          :key="item.id"
        >
          <div class="form-detail-preview_num">{{ index + 1 }}</div>
          <custom-layout :view-config="customViewConfig" position="detail1">
            <div class="weui-form-preview__item" slot="wd_matters">
              <label class="weui-form-preview__label">{{customLabel.wd_matters || "工作事项"}}</label>
              <span class="weui-form-preview__value weui-form-preview__value-icon"
                >{{ item.wd_matters }}
              </span>
            </div>
            <div class="weui-form-preview__item" slot="wd_progress">
              <label class="weui-form-preview__label">{{customLabel.wd_progress || "完成进度%"}}</label>
              <span class="weui-form-preview__value weui-form-preview__value-icon"
                >{{ item.wd_progress }}
              </span>
            </div>
            <div class="weui-form-preview__item" slot="wd_problem">
              <label class="weui-form-preview__label">{{customLabel.wd_problem || "工作问题"}}</label>
              <span class="weui-form-preview__value weui-form-preview__value-icon"
                >{{ item.wd_problem }}
              </span>
            </div>
            <div class="weui-form-preview__item" slot="wd_measure">
              <label class="weui-form-preview__label">{{customLabel.wd_measure || "对策"}}</label>
              <span class="weui-form-preview__value weui-form-preview__value-icon"
                >{{ item.wd_measure }}
              </span>
            </div>
          </custom-layout>
        </div>
      </collapse>
      <collapse class="form-preview weui-form-preview" v-if="form.items2" :title="'工作计划（'+form.items2.length+'条）'">
        <div
          class="weui-form-preview__bd form-detail-preview"
          v-for="(item, index) in form.items2"
          :key="item.id"
        >
          <div class="form-detail-preview_num">{{ index + 1 }}</div>
          <custom-layout :view-config="customViewConfig" position="detail1">
            <div class="weui-form-preview__item" slot="wrd_matters">
              <label class="weui-form-preview__label">{{customLabel.wrd_matters || "工作事项"}}</label>
              <span class="weui-form-preview__value weui-form-preview__value-icon"
                >{{ item.wrd_matters }}
              </span>
            </div>
            <div class="weui-form-preview__item" slot="wrd_planbegindate" v-if="item.wrd_planbegindate">
              <label class="weui-form-preview__label">{{customLabel.wrd_planbegindate || "计划开始时间"}}</label>
              <span class="weui-form-preview__value weui-form-preview__value-icon"
                >{{ dateFormat(item.wrd_planbegindate, 'yyyy-MM-dd') }}
              </span>
            </div>
            <div class="weui-form-preview__item" slot="wrd_planenddate" v-if="item.wrd_planenddate">
              <label class="weui-form-preview__label">{{customLabel.wrd_planenddate || "计划完成时间"}}</label>
              <span class="weui-form-preview__value weui-form-preview__value-icon"
                >{{ dateFormat(item.wrd_planenddate, 'yyyy-MM-dd') }}
              </span>
            </div>
            <div class="weui-form-preview__item" slot="wrd_helpcontent" v-if="item.wrd_helpcontent">
              <label class="weui-form-preview__label">{{customLabel.wrd_helpcontent || "需要协作内容"}}</label>
              <span class="weui-form-preview__value weui-form-preview__value-icon"
                >{{ item.wrd_helpcontent }}
              </span>
            </div>
          </custom-layout>
        </div>
      </collapse>
    </div>
    <file-list :value="form.main.wr_attach" />

    <div class="footer-bar weui-dialog__ft" v-if="!readonly && isReportEmp">
      <router-link
        :to="'/oa/workreport_edit?id='+form.main.id"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
      >编辑</router-link>
      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="remove"
      >删除</a>
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import Collapse from "@/components/Collapse.vue";
import FileList from "@/components/FileList.vue";
import process from "@/mixins/process.js";

export default {
  components: {
    CustomLayout,
    Collapse,
    FileList
  },
  mixins: [process],
  data() {
    return {
      baseUrl: "/api/oa/workreport",
      codeField: "wr_code",
      statusField: "wr_statuscode",
      caller: "WorkReport",
      xtype: "oa-workreport-formpanel",
    };
  },
  mounted() {
    this.getCurrentEmployee()
  },
  computed: {
    isReportEmp() {
      return this.form.main.wr_pleasemanid == this.currEmp?.id
    }
  },
  methods: {
    getCurrentEmployee() {
      const me = this

      me.$ajax({
        url: "/api/document/employee/read/current"
      }).then(res => {
        me.currEmp = res.data.main
      })
    },
    remove() {
      const me = this

      me.$weui.confirm('确定删除单据？', () => {
        me.$ajax({
          url: "/api/oa/workreport/delete/" + me.form.main.id + "?caller=WorkReport",
          method: 'POST'
        }).then(res => {
          if(res.success) {
            me.$router.back();
          }
        }).catch(err => {
          me.$weui.topTips("删除失败", err);
        })
      })
    }
  }
}
</script>